import { Slideshow } from '@archetype-themes/modules/slideshow'
import { HTMLThemeElement } from '@archetype-themes/custom-elements/theme-element'

class IconTextSwiper extends HTMLThemeElement {
  connectedCallback() {
    super.connectedCallback()

    this.defaults = {
      adaptiveHeight: true,
      avoidReflow: true,
      pageDots: true,
      prevNextButtons: false,
      autoPlay: false
    }

    this.timeout
    this.slideshow = this.querySelector(`#IconTextSwiper-${this.sectionId}`)
    this.namespace = `.icon-text-swiper-${this.sectionId}`

    if (!this.slideshow) {
      return
    }

    const autoPlayData = this.slideshow.dataset.autoPlay;
    const autoPlay = autoPlayData && autoPlayData !== '0' ? Math.round(parseFloat(autoPlayData) * 1000) : false

    this.defaults.autoPlay = autoPlay

    this.init()
  }

  init() {
    const blockCount = this.slideshow.dataset.blockCount ? parseInt(this.slideshow.dataset.blockCount, 10) : null;

    // Do not wrap when only a few blocks
    if (blockCount <= 3) {
      this.defaults.wrapAround = false
    }
    const desktopColumnsPerRow = this.slideshow.dataset.desktopColumnsPerRow ? parseInt(this.slideshow.dataset.desktopColumnsPerRow, 10) : null;

    if(desktopColumnsPerRow && blockCount && blockCount <= desktopColumnsPerRow) {
      this.defaults.groupCells = '100%';
    }

    this.flickity = new Slideshow(this.slideshow, this.defaults)

    if(desktopColumnsPerRow && blockCount && blockCount <= desktopColumnsPerRow) {
      const pageDotElement = this.querySelector(`#IconTextSwiper-${this.sectionId} .flickity-page-dots`);
      if (pageDotElement) {
        pageDotElement.className = 'flickity-page-dots hide small--show';
      }
    }

    // Autoscroll to next slide on load to indicate more blocks
    // if (blockCount > 2) {
    //   this.timeout = setTimeout(
    //     function () {
    //       this.flickity.goToSlide(1)
    //     }.bind(this),
    //     1000
    //   )
    // }
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    if (this.flickity && typeof this.flickity.destroy === 'function') {
      this.flickity.destroy()
    }
  }

  onSectionDeselect() {
    if (this.flickity && typeof this.flickity.play === 'function') {
      this.flickity.play()
    }
  }

  onBlockSelect({ detail: { blockId } }) {
    const slide = this.slideshow.querySelector(`.icon-text-swiper-slide--${blockId}`)
    const index = parseInt(slide.dataset.index)

    clearTimeout(this.timeout)

    if (this.flickity && typeof this.flickity.pause === 'function') {
      this.flickity.goToSlide(index)
      this.flickity.pause()
    }
  }

  onBlockDeselect() {
    if (this.flickity && typeof this.flickity.play === 'function') {
      this.flickity.play()
    }
  }
}

customElements.define('icon-text-swiper-component', IconTextSwiper)
